/**
 * @generated SignedSource<<c94926c1c30dd9a7f66ea90f25556eb0>>
 * @relayHash 00fd2a6672448a2151fd40fdb18e28a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f51cf53f8dfe3f90ed629229c0a04f65575fbe9624eb347be8d57a5445973978

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_autodevAgentPickerBulkQuery$variables = {
  cloudId: string;
  issueAris: ReadonlyArray<string>;
};
export type ui_autodevAgentPickerBulkQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type ui_autodevAgentPickerBulkQuery = {
  response: ui_autodevAgentPickerBulkQuery$data;
  variables: ui_autodevAgentPickerBulkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAris"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "issueAris",
            "variableName": "issueAris"
          }
        ],
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 20
          },
          {
            "kind": "Variable",
            "name": "issueIds",
            "variableName": "issueAris"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isRankingLimitApplied"
          },
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rankCategory"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "devai_autodevRovoTemplates",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Literal",
            "name": "templatesFilter",
            "value": "ONLY"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f51cf53f8dfe3f90ed629229c0a04f65575fbe9624eb347be8d57a5445973978",
    "metadata": {},
    "name": "ui_autodevAgentPickerBulkQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fac0ed7e2f112b00391a0c79b3d87b29";

export default node;
